import BaseStore from 'customer-flows/stores/base-store'
import { type Awaitable } from 'customer-flows/utils/core'
import { context } from 'customer-flows/utils/core'

export default class ProgramTilesStoreClass extends BaseStore {
  @context('program') program: Awaitable<ProgramTiles>

  get tiles(): ProgramTile[] {
    return this.program.value?.tiles ?? []
  }

  get title(): string | undefined {
    return this.program.value?.title
  }
}

declare global {
  export type ProgramTilesStore = ProgramTilesStoreClass
  export interface StoreRegistry {
    'program/tiles': ProgramTilesStore
  }
}
